import Cookies from "js-cookie"
import { GetKeycloak } from "./keycloak"
import userSo from "stores/user"



export enum LOGIN_RESPONSE {
	LOGGED = "logged",
	NEEDS_OTP = "needs_otp",
	ERROR = "error",
	FORCE_2FA = "force-2fa",
}

export const getAppUrl = (url = "") => {
	return `/app/${url}`
}

class Auth {
	get(): string {
		return Cookies.get("zeroAuth")
	}
	getBearerToken(): string {
		let auth = this.get() ?? undefined
		if (!auth && GetKeycloak()?.authenticated) {
			GetKeycloak().updateToken(30);
			auth = "Bearer " + GetKeycloak().token
		}
		if (!auth && !!userSo.state.kioskKey) {
			auth = "Bearer " + userSo.state.kioskKey
		}
		return auth
	}
	remove() {
		Cookies.remove("zeroAuth")
	}
	set(auth: string) {
		Cookies.set(
			"zeroAuth",
			auth,
			//{ sameSite: "None", secure: true },
		)
	}
}

const authService = new Auth()
export default authService
